module.exports = __webpack_public_path__ + "img/light.e5e8a46a.svg";